import React, { Component, useState } from 'react'
import SRCards from '../../components/SRCards'
import {
    Button, Container, FormControl, InputLabel, Select, MenuItem, Paper,
    Dialog, DialogTitle, DialogContent, DialogActions, Snackbar, TextField,
    TableContainer, Table, TableHead, TableRow, TableCell, TableBody, TableFooter, Switch, FormControlLabel,
} from '@material-ui/core'
import CommonServiceApi from '../../services/common-service'
import { Alert, } from '@material-ui/lab';
import TicketApi from '../../services/ticket.service'
import InvoiceApi from '../../services/invoice.service'
import EstimateApi from '../../services/estimate.service'
import CustomerApi from '../../services/customer.service'
import SelectCompany from '../../components/SelectCompany';   

export default function DeleteList() {
    const [entity, setEntity] = useState('');
    const [dialog, setDialog] = useState(false);
    const [isEstIndependent, setIsEstIndependent] = useState(false);
    const [isInvIndependent, setIsInvIndependent] = useState(false);
    const [snackBar, setSnackBar] = useState('');
    const [confirmMsg, setConfirmMsg] = useState('');
    const [pageResponse, setPageResponse] = useState('');
    const [errorDialog, setErrorDialog] = useState(false);
    const [ticketSearchVal, setTicketSearchVal] = useState(null);
    const [ticketToBeDeleted, setTicketToBeDeleted] = useState(null);
    const [invoiceToBeDeleted, setInvoiceToBeDeleted] = useState(null);
    const [tickets, setTickets] = useState<string[]>([]);
    const [invoiceSearchVal, setInvoiceSearchVal] = useState(null);
    const [customers, setCustomers] = useState<string[]>([]);
    const [customerSearchVal, setCustomerSearchVal] = useState('');
    const [customerToBeDeleted, setCustomerToBeDeleted] = useState(null);
    const [estimates, setEstimates] = useState<string[]>([]);
    const [estimateToBeDeleted, setEstimateToBeDeleted] = useState(null);
    const [estimateSearchVal, setEstimateSearchVal] = useState(null);
    const [invoices, setInvoices] = useState<string[]>([]);
    const ticket_apiservices = new TicketApi();
    const invoice_apiservices = new InvoiceApi();
    const estimate_apiservices = new EstimateApi();
    const customer_apiservices = new CustomerApi();   
    const handleChange = async (e: any) => {
        switch (e.target.value) {
            case 1:
                setEntity('Customer');
                break;
            case 2:
                setEntity('Ticket');
                break;
            case 3:
                setEntity('Invoice');
                break;
            case 4:
                setEntity('Estimate');
        }
    }
    const confirmCustomer = async ( customerId: any, customerIdentifier: any) => {
        let res = `This operation will delete customer - ${customerIdentifier} .`
        setDialog(true);
        setConfirmMsg(res);
        setCustomerToBeDeleted(customerId);
        return
    }
    const confirmTicket = async (ticketId: any, ticketNumber: any) => {
        let res = `This operation will delete ticket - ${ticketNumber} 
                    along with its related invoices, estimates, checklists, 
                    assignments, forms, notes and timecards.`
        setDialog(true);
        setConfirmMsg(res);
        setTicketToBeDeleted(ticketId);
        return
    }
    const confirmInvoice = async (invoiceId: any, invoiceNumber: any) => {
        let res = `This operation will delete invoice - ${invoiceNumber} 
                    along with its invoice items.`
        setDialog(true);
        setConfirmMsg(res);
        setInvoiceToBeDeleted(invoiceId);
        return
    }
    const confirmEstimate = async (estimateId: any, estimateNumber: any) => {
        let res = `This operation will delete estimate - ${estimateNumber} 
                    along with its items.`
        setDialog(true);
        setConfirmMsg(res);
        setEstimateToBeDeleted(estimateId);
        return
    }
    const cancel = () => {
        setDialog(false);
        setSnackBar('info');
        setPageResponse(`Deletion Cancelled.`);
    }
    const deleteEntity = async () => {
        let response;
        switch (entity) {
            case 'Customer': {
                response = await customer_apiservices.deleteCustomer(customerToBeDeleted);
                break;
            }
            case 'Estimate': {
                response = await estimate_apiservices.deleteEstimate(estimateToBeDeleted);
                break;
            }
            case 'Invoice': {
                response = await invoice_apiservices.deleteInvoice(invoiceToBeDeleted);
                break;
            }
            case 'Ticket': {
                response = await ticket_apiservices.deleteTicket(ticketToBeDeleted);
                break;
            }
        }
        if (response[0] && response[0].isActive === false) {
            let updated: any;
            switch (entity) {
                case 'Customer': {
                    updated = await customer_apiservices.getCustomers(customerSearchVal);
                    setCustomers(updated);
                    break;
                }
                case 'Estimate': {
                    updated = await estimate_apiservices.getEstimates(estimateSearchVal, isEstIndependent);
                    setEstimates(updated);
                    break;
                }
                case 'Invoice': {
                    updated = await invoice_apiservices.getInvoices(invoiceSearchVal, isInvIndependent);
                    setInvoices(updated);
                    break;
                }
                case 'Ticket': {
                    updated = await ticket_apiservices.getTickets(ticketSearchVal);
                    setTickets(updated);
                    break;
                }
            }
            setDialog(false);
            setSnackBar('success');
            setPageResponse("Deleted Successfully.");
        }
        else {
            let msg;
            if (response && response.message && response.description) {
                msg = `Delete Failed: ${response.message} - ${response.description}`
            } else {
                msg = `Delete Failed.`
            }
            setDialog(false);
            setSnackBar('error');
            setPageResponse(msg);
        }
    }
    const onClose = () => {
        setErrorDialog(false)
    }
    const onCustomerSearch = async (e: any) => {
        if (e.key === 'Enter') {
            const response: any = await customer_apiservices.getCustomers(
                e.target.value
            );
            setCustomers(response);
            setCustomerSearchVal(e.target.value);
        }
    }
    const onEstimateSearch = async (e: any) => {
        if (e.key === 'Enter') {
            const response = await estimate_apiservices.getEstimates(
                e.target.value, isEstIndependent
            );
            setEstimates(response);
            setEstimateSearchVal(e.target.value);
        }
    }
    const onInvoiceSearch = async (e: any) => {
        if (e.key === 'Enter') {
            const response = await invoice_apiservices.getInvoices(
                e.target.value, isInvIndependent
            );
            setInvoices(response);
            setInvoiceSearchVal(e.target.value);
        }
    }
    const onTicketSearch = async (e: any) => {
        if (e.key === 'Enter') {
            const response = await ticket_apiservices.getTickets(
                e.target.value
            );
            setTickets(response);
            setTicketSearchVal(e.target.value);
        }
    }
    return (
        <>
            <SRCards />
            <Container>
                <SelectCompany/>
                <br/><br/>
                <FormControl fullWidth className='rediscache_body'>
                    <InputLabel id="demo-simple-select-label">Modules</InputLabel>
                    <Select
                        onChange={handleChange}
                    >
                        <MenuItem value={1}>Customer</MenuItem> 
                        <MenuItem value={2}>Ticket</MenuItem>
                        <MenuItem value={3}>Invoice</MenuItem>
                        <MenuItem value={4}>Estimate</MenuItem>
                    </Select>
                </FormControl>
                <br /> <br /> 
                {entity === 'Customer' &&
                    <>
                        <TextField
                            style={{ padding: 16 }}
                            variant="outlined"
                            onKeyDown={(e) => onCustomerSearch(e)}
                            placeholder='Search Customer..' />
                        <TableContainer
                            component={Paper}
                            style={{
                                padding: 10, margin: 16
                            }}
                        >
                            <Table
                                style={{
                                    minWidth: 700
                                }}
                                aria-label="customized table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Action</TableCell>
                                        <TableCell>Customer Name</TableCell>
                                        <TableCell>Customer ID</TableCell>
                                        <TableCell>Customer Type</TableCell>
                                        <TableCell>Primary/Secondary</TableCell>
                                    </TableRow>
                                </TableHead>
                                {customers.length > 0 ?
                                    customers.map((customer: any) => {
                                        return (
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell>
                                                        <Button
                                                            style={{ margin: 10 }}
                                                            variant='outlined'
                                                            onClick={() => confirmCustomer(
                                                                customer.id,
                                                                customer.customerIdentifier
                                                            )
                                                            }
                                                        >
                                                            Delete
                                                        </Button>
                                                    </TableCell>
                                                    <TableCell>
                                                        {customer.displayName}
                                                    </TableCell>
                                                    <TableCell>
                                                        {customer.customerIdentifier}
                                                    </TableCell>
                                                    <TableCell>
                                                        Root Customer
                                                    </TableCell>
                                                    <TableCell>
                                                        Primary
                                                    </TableCell>
                                                </TableRow>
                                                {customer.serviceAddresses.length > 1 ?
                                                    customer.serviceAddresses
                                                        .filter((temp: any) =>
                                                            (!temp.isParent)
                                                        )
                                                        .map((temp: any) => {
                                                            return (
                                                                <TableRow>
                                                                    <TableCell>
                                                                        <Button
                                                                            style={{ margin: 10 }}
                                                                            variant='outlined'
                                                                            onClick={() => confirmCustomer(temp.customerId,customer.customerIdentifier)}
                                                                        >
                                                                            Delete
                                                                        </Button>
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {temp.displayName}
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {temp.customerIdentifier}
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        Service
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        Secondary
                                                                    </TableCell>
                                                                </TableRow>)
                                                        }) : null}
                                            </TableBody>
                                        )
                                    }) : null}
                                <TableFooter>
                                    <TableRow>
                                    </TableRow>
                                </TableFooter>
                            </Table>
                        </TableContainer>
                    </>
                }
                {entity === 'Ticket' &&
                    <>
                        <TextField
                            style={{ padding: 16 }}
                            variant="outlined"
                            onKeyDown={(e) => onTicketSearch(e)}
                            placeholder='Search Ticket..' />
                        <TableContainer
                            component={Paper}
                            style={{ padding: 10, margin: 16 }}
                        >
                            <Table
                                style={{ minWidth: 700 }}
                                aria-label="customized table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Action</TableCell>
                                        <TableCell>Ticket Number</TableCell>
                                        <TableCell>Customer Name</TableCell>
                                        <TableCell>Address</TableCell>
                                        <TableCell>Job Type</TableCell>
                                        <TableCell>Description</TableCell>
                                        <TableCell>Start Time</TableCell>
                                        <TableCell>End Time</TableCell>
                                        <TableCell>Job Status</TableCell>
                                    </TableRow>
                                </TableHead>
                                {tickets.length ?
                                    tickets.map((ticket: any) => {
                                        return (
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell>
                                                        <Button
                                                            style={{ margin: 10 }}
                                                            variant='outlined'
                                                            onClick={() => confirmTicket(ticket.id, ticket.ticketNumber)}
                                                        >
                                                            Delete
                                                        </Button>
                                                    </TableCell>
                                                    <TableCell>
                                                        {ticket.ticketNumber}
                                                    </TableCell>
                                                    <TableCell>
                                                        {ticket.serviceAddress && ticket.serviceAddress.displayName ?
                                                            ticket.serviceAddress.displayName : ''}
                                                    </TableCell>
                                                    <TableCell>
                                                        {ticket.serviceAddress && ticket.serviceAddress.addressLine1 ?
                                                            ticket.serviceAddress.addressLine1 : ''},
                                                        {ticket.serviceAddress && ticket.serviceAddress.city ?
                                                            ticket.serviceAddress.city : ''},
                                                        {ticket.serviceAddress && ticket.serviceAddress.state ?
                                                            ticket.serviceAddress.state : ''},
                                                        {ticket.serviceAddress && ticket.serviceAddress.zipcode ?
                                                            ticket.serviceAddress.zipcode : ''}
                                                    </TableCell>
                                                    <TableCell>
                                                        {ticket.jobType}
                                                    </TableCell>
                                                    <TableCell>
                                                        {ticket.jobDescription}
                                                    </TableCell>
                                                    <TableCell>
                                                        {ticket.startTime}
                                                    </TableCell>
                                                    <TableCell>
                                                        {ticket.endTime}
                                                    </TableCell>
                                                    <TableCell>
                                                        {ticket.jobStatus}
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        )
                                    }) : null}
                                <TableFooter>
                                    <TableRow>
                                    </TableRow>
                                </TableFooter>
                            </Table>
                        </TableContainer>
                    </>
                }
                {entity === 'Invoice' &&
                    <>
                        <TextField
                            style={{ padding: 20 }}
                            variant="outlined"
                            onKeyDown={(e) => onInvoiceSearch(e)}
                            placeholder='Search Invoice..' />
                        <FormControlLabel
                            style={{
                                padding: 16
                            }}
                            control={
                                <Switch
                                    checked={isInvIndependent}
                                    onChange={(e: any) => setIsInvIndependent(!isInvIndependent)}
                                />
                            }
                            label="Search Independent Invoice"
                        />
                        <TableContainer
                            component={Paper}
                            style={{
                                width: 1500
                            }}
                        >
                            <Table
                                style={{
                                    minWidth: 700,
                                }}
                                aria-label="customized table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Action</TableCell>
                                        <TableCell>Invoice</TableCell>
                                        <TableCell>Invoice Date</TableCell>
                                        <TableCell>Customer Name</TableCell>
                                        <TableCell>Customer Location</TableCell>
                                        <TableCell>Job Type</TableCell>
                                        <TableCell>Estimated Hours</TableCell>
                                        <TableCell>Sub Total</TableCell>
                                        <TableCell>Tax</TableCell>
                                        <TableCell>Total</TableCell>
                                    </TableRow>
                                </TableHead>
                                {invoices.length > 0 ?
                                    invoices.map((invoice: any) => {
                                        return (
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell>
                                                        <Button
                                                            style={{ margin: 10 }}
                                                            variant='outlined'
                                                            onClick={() => confirmInvoice(invoice.id, invoice.invoiceNumber)}
                                                        >
                                                            Delete
                                                        </Button>
                                                    </TableCell>
                                                    <TableCell>
                                                        {invoice.invoiceNumber}
                                                    </TableCell>
                                                    <TableCell>
                                                        {invoice.invoiceDate}
                                                    </TableCell>
                                                    <TableCell>
                                                        {invoice.serviceAddress.displayName}
                                                    </TableCell>
                                                    <TableCell>
                                                        {invoice.serviceAddress.addressLine1},
                                                        {invoice.serviceAddress.city},
                                                        {invoice.serviceAddress.state},
                                                        {invoice.serviceAddress.zipcode}
                                                    </TableCell>
                                                    <TableCell>
                                                        {invoice.jobType}
                                                    </TableCell>
                                                    <TableCell>
                                                        {invoice.estimatedHours}
                                                    </TableCell>
                                                    <TableCell>
                                                        {invoice.subTotal}
                                                    </TableCell>
                                                    <TableCell>
                                                        {invoice.tax}
                                                    </TableCell>
                                                    <TableCell>
                                                        {invoice.total}
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        )
                                    }) : null}
                                <TableFooter>
                                    <TableRow>
                                    </TableRow>
                                </TableFooter>
                            </Table>
                        </TableContainer>
                    </>
                }
                {entity === 'Estimate' &&
                    <>
                        <TextField
                            style={{ padding: 20 }}
                            variant="outlined"
                            onKeyDown={(e) => onEstimateSearch(e)}
                            placeholder='Search Estimate..' />
                        <FormControlLabel
                            style={{
                                padding: 16
                            }}
                            control={
                                <Switch
                                    checked={isEstIndependent}
                                    onChange={(e: any) => setIsEstIndependent(!isEstIndependent)}
                                />
                            }
                            label="Search Independent Estimate"
                        />
                        <TableContainer
                            component={Paper}
                            style={{
                                width: 1500
                            }}
                        >
                            <Table
                                style={{
                                    minWidth: 700,
                                }}
                                aria-label="customized table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Action</TableCell>
                                        <TableCell>Estimate</TableCell>
                                        <TableCell>Estimate Date</TableCell>
                                        <TableCell>Customer Name</TableCell>
                                        <TableCell>Customer Location</TableCell>
                                        <TableCell>Job Type</TableCell>
                                        <TableCell>Estimated Hours</TableCell>
                                        <TableCell>Sub Total</TableCell>
                                        <TableCell>Tax</TableCell>
                                        <TableCell>Total</TableCell>
                                        <TableCell>Estimate Status</TableCell>
                                    </TableRow>
                                </TableHead>
                                {estimates.length > 0 ?
                                    estimates.map((estimate: any) => {
                                        return (
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell>
                                                        <Button
                                                            style={{ margin: 10 }}
                                                            variant='outlined'
                                                            onClick={() => confirmEstimate(
                                                                estimate.id,
                                                                estimate.estimateNumber
                                                            )
                                                            }
                                                        >
                                                            Delete
                                                        </Button>
                                                    </TableCell>
                                                    <TableCell>
                                                        {estimate.estimateNumber}
                                                    </TableCell>
                                                    <TableCell>
                                                        {estimate.estimateDate}
                                                    </TableCell>
                                                    <TableCell>
                                                        {
                                                            estimate.serviceAddress ?
                                                                estimate.serviceAddress.displayName ?
                                                                    estimate.serviceAddress.displayName :
                                                                    estimate.serviceAddress.customerId ?
                                                                        estimate.serviceAddress.customerId.name ?
                                                                            estimate.serviceAddress.customerId.name :
                                                                            estimate.serviceAddress.customerId.displayName ?
                                                                                estimate.serviceAddress.customerId.displayName :
                                                                                estimate.serviceAddress.customerId.firstname + ' ' + estimate.serviceAddress.customerId.lastname :
                                                                        '-' :
                                                                '-'
                                                        }
                                                    </TableCell>
                                                    <TableCell>
                                                        {estimate.serviceAddress.addressLine1},
                                                        {estimate.serviceAddress.city},
                                                        {estimate.serviceAddress.state},
                                                        {estimate.serviceAddress.zipcode}
                                                    </TableCell>
                                                    <TableCell>
                                                        {estimate.jobType}
                                                    </TableCell>
                                                    <TableCell>
                                                        {estimate.estimatedHours}
                                                    </TableCell>
                                                    <TableCell>
                                                        {estimate.subTotal}
                                                    </TableCell>
                                                    <TableCell>
                                                        {estimate.tax}
                                                    </TableCell>
                                                    <TableCell>
                                                        {estimate.total}
                                                    </TableCell>
                                                    <TableCell>
                                                        {estimate.estimateStatus}
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        )
                                    }) : null}
                                <TableFooter>
                                    <TableRow>
                                    </TableRow>
                                </TableFooter>
                            </Table>
                        </TableContainer>
                    </>
                }
                <Dialog
                    open={dialog}
                    onClose={() => {
                        setDialog(false)
                    }}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">
                        {'Confirmation!'}
                    </DialogTitle>
                    <DialogContent>
                        {confirmMsg}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={
                                () => {
                                    setConfirmMsg('Processing...')
                                    deleteEntity()
                                }
                            }
                        >
                            Confirm
                        </Button>
                        <Button
                            onClick={
                                () => cancel()
                            }
                            autoFocus
                        >
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={errorDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogContent>
                        Please select the Company and provide both Entity & Entity Identifier before proceeding.
                    </DialogContent>
                    <Button onClick={onClose}>Ok</Button>
                </Dialog>
                <Snackbar
                    open={snackBar === '' ? false : true}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    autoHideDuration={6000}
                    onClose={() => {
                        setSnackBar('')
                    }}
                >
                    <Alert
                        severity={snackBar === 'error' ? 'error' : 'success'}
                        onClose={() => {
                            setSnackBar('')
                        }
                        }>
                        {pageResponse}
                    </Alert>
                </Snackbar>
            </Container>
        </>
    )
}
